import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import type { AccessCentreUsersApiResponse } from 'domains/accessCentre/types';

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

type UseGetUsersListParams = {
    limit?: number;
    offset?: number;
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<AccessCentreUsersApiResponse, Error>;
};

const useGetUsersList = ({
    limit = DEFAULT_LIMIT,
    offset = DEFAULT_OFFSET,
    searchTerm,
    reactQueryOptions,
}: UseGetUsersListParams = {}) => {
    const queryKey = QueryKeys.ACCESS_CENTRE_USERS(limit, offset, searchTerm);
    const params: { limit: number; offset: number; search?: string } = { limit, offset };
    if (searchTerm?.trim()) {
        params.search = searchTerm.trim();
    }
    const axiosOptions = { params };

    return useQuery<AccessCentreUsersApiResponse>(
        queryKey,
        CuredApiPaths.ACCESS_CENTRE_USERS,
        reactQueryOptions,
        axiosOptions
    );
};

export default useGetUsersList;
